import { Link } from "@remix-run/react";
import clsx from "clsx";

import { PRODUCT_NAME } from "~/lib/env.shared";

interface LogoProps {
    size?: "sm" | "md" | "lg";
}

const sizeClasses = {
    sm: "text-2xl",
    md: "text-3xl sm:text-4xl",
    lg: "text-5xl",
};

export const LogoSmall: React.FC = () => (
    <Link
        to="/sessions"
        className="text-center text-3xl font-bold tracking-tight text-rose-900"
        style={{ fontFamily: "Sinhala MN" }}
    >
        {PRODUCT_NAME}
    </Link>
);

const Logo: React.FC<LogoProps> = ({ size = "lg" }) => (
    <div className="flex flex-col items-center justify-center">
        <Link
            to="/"
            className={clsx(
                "text-rose-800 text-center font-bold mx-auto tracking-tight",
                sizeClasses[size],
            )}
            style={{ fontFamily: "Sinhala MN", width: 200, lineHeight: 0.8 }}
        >
            {PRODUCT_NAME}
        </Link>
    </div>
);

export const DisplayHeader: React.FC<{
    children: React.ReactNode;
    className?: string;
}> = (props) => (
    <div
        className={clsx(
            "text-4xl text-rose-900 text-center font-bold",
            props.className,
        )}
        style={{ fontFamily: "Sinhala MN" }}
    >
        {props.children}
    </div>
);

export default Logo;
